import React from 'react';

import RenderSliderImage from './render-slider-image';

const SliderElement = ({ name, text }) => (
	<div>
		<div>
			<RenderSliderImage name={name}/>
		</div>
		<div>
			<h5 style={{ textAlign: 'center' }}>{text}</h5>
		</div>
	</div>
);

export default SliderElement;
